document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".block-slider .swiper");

  if (blocks.length === 0) {
    return;
  }

  [...blocks].forEach((item) => {
    const delayvalue = item.dataset.autoplay;
    let autoplay = false;
    if (typeof delayvalue !== "undefined") {
      autoplay = {
        delay: delayvalue * 1000,
      };
    }
    const swiper = new Swiper(item, {// eslint-disable-line
      // Optional parameters
      loop: true,
      lazy: true,
      autoplay,
      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
});
